import { render, staticRenderFns } from "./FCard.vue?vue&type=template&id=61635301"
import script from "./FCard.vue?vue&type=script&lang=js"
export * from "./FCard.vue?vue&type=script&lang=js"
import style0 from "./FCard.vue?vue&type=style&index=0&id=61635301&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports